import { render, staticRenderFns } from "./AlterarCarenciaDialog.vue?vue&type=template&id=4567877f&"
import script from "./AlterarCarenciaDialog.vue?vue&type=script&lang=js&"
export * from "./AlterarCarenciaDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports